// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xh09I"};